export default {"src":"https://marketing-edge-assets.lemonade.com/_next/static/media/check.db007bc2.svg","height":19,"width":18,"blurWidth":0,"blurHeight":0};